import { lazy, Suspense, type ComponentProps } from "react";

const AlertsSectionImpl = lazy(() => import("./alerts-section-impl"));

export function AlertsSection(
  props: ComponentProps<typeof AlertsSectionImpl>,
) {
  return (
    <Suspense fallback={null}>
      <AlertsSectionImpl {...props} />
    </Suspense>
  );
}
